import routerConstants from '@/const/routerConstants';

export default [
  // allDoc
  {
    name: routerConstants.ApprDoc,
    path: '/apprDoc',
    meta: { bottomNav: true },
    component: () => import('@/views/allDoc/ApprDocView.vue'),
  },
  {
    name: routerConstants.MyBox,
    path: '/myBox',
    meta: { bottomNav: true },
    component: () => import('@/views/allDoc/MyBoxView.vue'),
  },
  {
    name: routerConstants.ReferBox,
    path: '/referBox',
    meta: { bottomNav: true },
    component: () => import('@/views/allDoc/ReferBoxView.vue'),
  },

  {
    name: routerConstants.WorkLog,
    path: '/workLog',
    meta: { bottomNav: true },
    component: () => import('@/views/allDoc/WorkLogMainView.vue'),
  },

  // etc
  {
    name: routerConstants.Alert,
    path: '/alert',
    meta: { bottomNav: true },
    component: () => import('@/views/etc/AlertView.vue'),
  },
  {
    name: routerConstants.NewMember,
    path: '/newMember',
    meta: { bottomNav: true },
    component: () => import('@/views/etc/NewMemberView.vue'),
  },
  {
    name: routerConstants.Board,
    path: '/board',
    meta: { bottomNav: true },
    component: () => import('@/views/etc/BoardView.vue'),
  },

  // emp status
  {
    name: routerConstants.CertiSta,
    path: '/certiSta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/emp/CertiStaView.vue'),
  },

  // pay status
  {
    name: routerConstants.SelectPayGubun,
    path: '/paySta/selectPayGubun',
    meta: { bottomNav: true },
    component: () => import('@/views/status/pay/SelectPayGubun.vue'),
  },

  // work status
  {
    name: routerConstants.WorkTimeSta,
    path: '/workTimeSta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/work/WorkTimeStaView.vue'),
  },
  {
    name: routerConstants.OrgGntWorkSta,
    path: '/orgGntWorkSta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/work/OrgGntWorkStaView.vue'),
  },
  {
    name: routerConstants.AnnualHolidaySta,
    path: '/annualHolidaySta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/work/HolidayStaView.vue'),
  },
  {
    name: routerConstants.MaternityHolidaySta,
    path: '/maternityHolidaySta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/work/HolidayStaView.vue'),
  },
  {
    name: routerConstants.WorkOverTimeSta,
    path: '/workOverTimeSta',
    meta: { bottomNav: true },
    component: () => import('@/views/status/work/WorkOverTimeStaView.vue'),
  },

  // ---------------------- test ----------------------
  {
    name: 'callAppTest',
    path: '/callAppTest',
    component: () => import('@/views/test/callAppTest.vue'),
  },
];
